import bigdataTable from './vue-bigdata-table.vue';
export default bigdataTable;
